var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBubbleRainbow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7425_11766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 11C24.0101 11 11 24.0101 11 40C11 45.5752 12.5624 50.9294 15.524 55.544L11.1305 66.5133C10.8622 67.1875 11.0181 67.956 11.5329 68.4707C11.8773 68.8151 12.3413 69 12.8125 69C13.0409 69 13.2656 68.9565 13.4867 68.8695L24.456 64.476C29.0706 67.4376 34.4247 69 40 69C55.9899 69 69 55.9899 69 40C69 24.0101 55.9899 11 40 11ZM40 65.375C34.8307 65.375 29.8826 63.8453 25.6957 60.9489C25.3912 60.735 25.0287 60.6262 24.6663 60.6262C24.4379 60.6262 24.2095 60.6698 23.992 60.7567L16.0677 63.9323L19.2432 56.008C19.468 55.4425 19.3955 54.8009 19.0511 54.3042C16.1547 50.1174 14.625 45.1693 14.625 40C14.625 26.0075 26.0075 14.625 40 14.625C53.9925 14.625 65.375 26.0075 65.375 40C65.375 53.9925 53.9925 65.375 40 65.375Z",
    fill: "url(#paint0_linear_7425_11766)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7425_11766",
    x1: 69,
    y1: 52.6875,
    x2: 11,
    y2: 52.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ABF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#6C5CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#42B2FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7425_11766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbleRainbow);
export default __webpack_public_path__ + "static/media/chat-bubble-rainbow.0b537a2530f7af3fee795d15ddfbe207.svg";
export { ForwardRef as ReactComponent };